import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { siteConfig } from '../data/config';

const ProPage = () => {
    return (
        <div className="app">
            <Header 
                name={siteConfig.humoristName} 
                tagline={siteConfig.tagline}
                height="20vh"
                centered={true}
            />
            <section className="pro-section">
                <div className="container">
                    <h1>Espace Pro</h1>
                    
                    <div className="pro-content">
                        <h2>Informations pour les professionnels</h2>
                        <p>Vous êtes un professionnel du spectacle et vous souhaitez travailler avec Antoine Officieux ? Retrouvez ici toutes les informations nécessaires.</p>
                        
                        <h2>Contact</h2>
                        <p>Pour toute demande de booking ou de collaboration professionnelle :</p>
                        <p>Email : {siteConfig.contactEmail}</p>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default ProPage;